var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame48095977(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 46,
    width: 45,
    height: 45,
    rx: 22.25,
    transform: "rotate(-180 46 46)",
    stroke: "#FFFAE6",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7418 18.996C31.6441 18.5997 31.453 18.2383 31.1876 17.9477C30.9221 17.6572 30.5917 17.4476 30.2291 17.3399C28.8847 16.9367 23.5059 16.9301 23.5059 16.9301C23.5059 16.9301 18.1281 16.9236 16.7828 17.309C16.4204 17.4216 16.0906 17.6342 15.8251 17.9261C15.5596 18.2181 15.3673 18.5797 15.2666 18.9763C14.912 20.4448 14.9086 23.4906 14.9086 23.4906C14.9086 23.4906 14.9052 26.5514 15.2572 28.005C15.4546 28.8086 16.0341 29.4435 16.7708 29.6601C18.129 30.0633 23.4931 30.0699 23.4931 30.0699C23.4931 30.0699 28.8718 30.0765 30.2162 29.692C30.579 29.5845 30.9097 29.3754 31.1758 29.0854C31.4418 28.7955 31.634 28.4347 31.7333 28.0387C32.0887 26.5711 32.0913 23.5263 32.0913 23.5263C32.0913 23.5263 32.1084 20.4645 31.7418 18.996ZM21.7854 26.3123L21.7897 20.6858L26.2601 23.5038L21.7854 26.3123Z",
    fill: "#FFFAE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame48095977);
export default __webpack_public_path__ + "static/media/frame-48095977.5fe7582018942709adc9e993ce7501dd.svg";
export { ForwardRef as ReactComponent };